import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { getItem, createItem, updateItem } from '../../controller/Control';
import { Button, Input, DatePicker, Form, InputNumber, Select, Popconfirm } from 'antd';
import { IoArrowBackCircle } from "react-icons/io5";
import { PiNotePencil } from "react-icons/pi";
import { MdOutlineCancel } from "react-icons/md";
import Evolution from '../Evolution';
import moment from 'moment';

import './styles.css'

interface PacientesMoreProps {
  userId: string;
	back: () => void;
	printDiv: () => void
}

const PatientMore: React.FC<PacientesMoreProps> = ({userId, back, printDiv}) => {
	const [dataPatient, setDataPatient] = useState<any>({})
	const [dataFirst, setDataFirst] = useState<any>({})
	const [isEdit, setIsEdit] = useState<boolean>(false)
	const [actionFirst, setActionFirst] = useState<any>({
		isView: false,
		isEdit: false,
		isAdd: false
	})
	const [form] = Form.useForm();
	const [formFirst] = Form.useForm()
	const [idFirst, setIdFirst] = useState<string>('')
	const navigate = useNavigate();

	let editPatient = useRef<HTMLDivElement>(null)

	const getData = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const data = await getItem(`${process.env.REACT_APP_API_SERVER}/patient/${userId}`, token)
		if(data && Object.keys(data).length > 0){
			setDataPatient(data)
			getDataFirst()
		}
	}

	const getDataFirst = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const data = await getItem(`${process.env.REACT_APP_API_SERVER}/first-time/${userId}`, token)
		if(data && Object.keys(data).length > 0){
			setDataFirst(data)
		}
	}

	useEffect(() => {getData()}, [0])

	useEffect(() => {getData()}, [isEdit, actionFirst])

	const editForm = () => {
		setIsEdit(true)
		form.setFieldsValue({
			name: dataPatient.name,
			document: dataPatient.document,
			birthdate: dataPatient.birthdate ? moment(dataPatient.birthdate) : null,
			age: dataPatient.age,
			from: dataPatient.from,
			live: dataPatient.live,
			occupation: dataPatient.occupation,
			phone: dataPatient.phone,
			email: dataPatient.email,
			status: dataPatient.status,
			laterality: dataPatient.laterality,
			gender: dataPatient.gender,
		});
		if (editPatient.current) {
			editPatient.current.scrollIntoView({ behavior: 'smooth' }); // Opcional: behavior smooth para un desplazamiento suave
		} 
	}

	const editFirstForm = (id: string) => {
		setIdFirst(id)
		setActionFirst({isView: true, isEdit: true, isAdd: false})
		formFirst.setFieldsValue(dataFirst);
		if (editPatient.current) {
			editPatient.current.scrollIntoView({ behavior: 'smooth' }); // Opcional: behavior smooth para un desplazamiento suave
		} 
	}

	const goToEditPatient = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const values = form.getFieldsValue()
		const update: any = await updateItem(`${process.env.REACT_APP_API_SERVER}/patient/${userId}`, values, token)
		if(update._id){
			form.resetFields();
			setIsEdit(false)
		}
	}

	const goToAddFirst = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const values = formFirst.getFieldsValue()
		const create: any = await createItem(`${process.env.REACT_APP_API_SERVER}/first-time`, {id_patient: userId, ...values}, token)
		if(create === 401){
			alert('Error, por favor finalice sesión e ingrese nuevamente')
		}
		if(create._id){
			formFirst.resetFields();
			setActionFirst({isView: false, isEdit: false, isAdd: false})
		}
	}

	const goToEditFirst = async() => {
		const user: any = sessionStorage.getItem('userData')
		const userJson = JSON.parse(user)
		const token = userJson.token
		const values = formFirst.getFieldsValue()
		const update: any = await updateItem(`${process.env.REACT_APP_API_SERVER}/first-time/${idFirst}`, values, token)
		if(update._id){
			formFirst.resetFields();
			setActionFirst({isView: false, isEdit: false, isAdd: false})
		}
	}

	return(
		<div className='p-5'>
			<div  ref={editPatient}><IoArrowBackCircle size={35} color='#B71C1C' style={{cursor: 'pointer'}} onClick={back}/></div>

			<div className='justify-center flex-col items-center patient' style={isEdit ? {display: 'flex'} : {display: 'none'}}>
				<h1 className='text-2xl text-text-menu my-5'>Modificar un Paciente</h1>
				<div className='w-96 m-5 border-[1px] border-slate-400 p-5 rounded-lg'>
					<Form
						layout='vertical'
						style={{maxWidth: 400}}
						form={form}
					>

						<Form.Item label="Nombre" name="name" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item label="Documento" name="document" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item
							label="Cumpleaños"
							name="birthdate"
							rules={[{ required: true, message: 'Por favor llene este campo' }]}
						>
							<DatePicker style={{ width: '100%' }}/>
						</Form.Item>

						<Form.Item
							label="Edad"
							name="age"
							rules={[{ required: true, message: 'Por favor llene este campo' }]}
						>
							<InputNumber style={{ width: '100%' }} />
						</Form.Item>

						<Form.Item label="Originario de" name="from" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item label="Vive en" name="live" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item label="Ocupacion" name="occupation" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item label="Teléfono" name="phone" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item label="Correo" name="email" rules={[{ type: 'email', required: true, message: 'Por favor llene este campo' }]}>
							<Input />
						</Form.Item>

						<Form.Item label="Estado Civil" name="status">
							<Select>
								<Select.Option value="soltero">Soltero</Select.Option>
								<Select.Option value="casado">Casado</Select.Option>
								<Select.Option value="divorciado">Divorciado</Select.Option>
								<Select.Option value="union de hecho">Unión de Hecho</Select.Option>
								<Select.Option value="viudo">Viudo</Select.Option>
							</Select>
						</Form.Item>

						<Form.Item label="Lateralidad" name="laterality">
							<Select>
								<Select.Option value="diestro">Diestro</Select.Option>
								<Select.Option value="siniestro">Siniestro</Select.Option>
							</Select>
						</Form.Item>

						<Form.Item label="Genero" name="gender">
						<Select>
								<Select.Option value="masculino">Masculino</Select.Option>
								<Select.Option value="femenino">Femenino</Select.Option>
							</Select>
						</Form.Item>

						<Form.Item>
							<Popconfirm 
								title="Seguro quiere modificar el paciente?"
								description="Esta acción no se puede deshacer"
								cancelText="Cancelar"
								onConfirm={goToEditPatient}
							>
								<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-hover-buttons text-sm' type="submit">
									Modificar
								</button>
							</Popconfirm>
							<button className='bg-red-600 text-white p-1.5 rounded-md hover:bg-red-700 text-sm mx-2' type="button" onClick={() => setIsEdit(false)}>
								Cancelar
							</button>
						</Form.Item>
					</Form>
				</div>
			</div>


			{/* FORMULARIO DE PRIMERA VEZ */}
			<div className='flex flex-col items-center patient' style={actionFirst.isView ? {display: 'flex'} : {display: 'none'}}>
				<h1 className='text-2xl text-text-menu my-5'>{actionFirst.isAdd ? 'Agregar Primera Vez' : 'Modificar Primera Vez'}</h1>
				<Form
					layout='vertical'
					style={{maxWidth: '100%'}}
					form={formFirst}
				>
					<div className='flex flex-row justify-around items-start flex-wrap'>
						<div className='w-96 m-5 border-[1px] border-slate-400 p-5 rounded-lg'>
							<h3 className='text-xl text-text-menu my-5'>Antecedentes</h3>
							<Form.Item label="Antecedentes Patologicos" name="antecedentes_patologicos" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input.TextArea autoSize />
							</Form.Item>

							<Form.Item label="Antecedentes Quirurgicos" name="antecedentes_quirurgicos" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input.TextArea autoSize />
							</Form.Item>
						</div>
						<div className='w-96 m-5 border-[1px] border-slate-400 p-5 rounded-lg'>
							<h3 className='text-xl text-text-menu my-5'>ToxicoAlergicos</h3>
							<Form.Item
								label="Alcohol"
								name="alcohol"
								rules={[{ required: true, message: 'Por favor llene este campo' }]}
							>
								<Input />
							</Form.Item>

							<Form.Item
								label="Tabaquismo"
								name="tabaquismo"
								rules={[{ required: true, message: 'Por favor llene este campo' }]}
							>
								<Input />
							</Form.Item>

							<Form.Item label="Drogas" name="drogas" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input />
							</Form.Item>

							<Form.Item label="Inmunizaciones" name="inmunizaciones" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input />
							</Form.Item>

							<Form.Item label="Otros" name="otros_toxico" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input />
							</Form.Item>
						</div>
						<div className='w-96 m-5 border-[1px] border-slate-400 p-5 rounded-lg'>
							<h3 className='text-xl text-text-menu my-5'>Antecedentes Familiares</h3>
							<Form.Item label="Padre Vivo:" name="padre_vivo" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Select>
									<Select.Option value="si">Si</Select.Option>
									<Select.Option value="no">No</Select.Option>
								</Select>
							</Form.Item>

							<Form.Item label="Enfermedades que padece:" name="padre_enfermedades" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input />
							</Form.Item>

							<Form.Item label="Madre Viva:" name="madre_viva" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Select>
									<Select.Option value="si">Si</Select.Option>
									<Select.Option value="no">No</Select.Option>
								</Select>
							</Form.Item>

							<Form.Item label="Enfermedades que padece:" name="madre_enfermedades" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input />
							</Form.Item>

							<Form.Item label="Hermanos Cuantos:" name="hermanos_cuantos" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input />
							</Form.Item>

							<Form.Item label="Vivos:" name="hermanos_vivos" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input />
							</Form.Item>

							<Form.Item label="Enfermedades que padecen:" name="hermanos_enfermedades" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input />
							</Form.Item>

							<Form.Item label="Otros" name="otros_familiares" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input />
							</Form.Item>
						</div>
						<div className='w-96 m-5 border-[1px] border-slate-400 p-5 rounded-lg'>
							<h3 className='text-xl text-text-menu my-5'>Cabeza y Cuello</h3>
							<Form.Item label="Cabeza y Cuello" name="cabeza_cuello" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input />
							</Form.Item>

							<Form.Item label="Lengua" name="lengua" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input />
							</Form.Item>

							<Form.Item label="Torax" name="torax" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input />
							</Form.Item>

							<Form.Item label="Abdomen" name="abdomen" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input />
							</Form.Item>

							<Form.Item label="Extremidades" name="extremidades" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input />
							</Form.Item>

							<Form.Item label="Pulso" name="pulso" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input />
							</Form.Item>

							<Form.Item label="Neurologico" name="neurologico" rules={[{ required: true, message: 'Por favor llene este campo' }]}>
								<Input />
							</Form.Item>
						</div>
					</div>
						

						<Form.Item className='text-center'>
							{actionFirst.isEdit ?
								<Popconfirm 
									title="Seguro quiere modificar estos datos?"
									description="Esta acción no se puede deshacer"
									cancelText="Cancelar"
									onConfirm={goToEditFirst}
								>
									<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-hover-buttons text-sm' type="submit">
										Modificar
									</button>
								</Popconfirm> :
								<button className='bg-buttons text-white p-1.5 rounded-md hover:bg-hover-buttons text-sm' type="submit" onClick={goToAddFirst}>
									Agregar
								</button>
							}
							<button className='bg-red-600 text-white p-1.5 rounded-md hover:bg-red-700 text-sm mx-2' type="button" onClick={() => setActionFirst({isView: false, isAdd: false, isEdit: false})}>
								Cancelar
							</button>
						</Form.Item>
				</Form>
			</div>


			<div className='my-5 flex lg:flex-row flex-col'>
				<div className='p-5 border-2 rounded-md border-text-menu lg:w-1/2 w-full lg:mx-2 relative'>
					{dataPatient && dataPatient.name ? (
						<div>
							<h1 className='text-text-menu' style={{fontSize: '2em'}}>Datos Personales</h1>
							<p><strong>Nombre: </strong>{dataPatient.name}</p>
							<p><strong>Documento: </strong>{dataPatient.document}</p>
							<p><strong>Fecha de Nacimiento: </strong>{dataPatient.birthdate 
								? new Date(dataPatient.birthdate).toLocaleDateString('es-ES', {
										year: 'numeric',
										month: 'long',
										day: 'numeric'
									})
								: 'Fecha no disponible'}
							</p>
							<p><strong>Edad: </strong>{dataPatient?.age}</p>
							<p><strong>Originario: </strong>{dataPatient.from}</p>
							<p><strong>Vive en: </strong>{dataPatient.live}</p>
							<p><strong>Ocupacion: </strong>{dataPatient.occupation}</p>
							<p><strong>Teléfono: </strong>{dataPatient.phone}</p>
							<p><strong>Correo: </strong>{dataPatient.email}</p>
							<p><strong>Estado Civil: </strong>{dataPatient.status}</p>
							<p><strong>Lateralidad: </strong>{dataPatient.laterality}</p>
							<p><strong>Genero: </strong>{dataPatient.gender}</p>
							<div className='absolute bottom-2 right-2'>
								{!isEdit && <PiNotePencil size={35} color='#B71C1C' style={{cursor: 'pointer'}} onClick={editForm}/>}
							</div>
						</div>
					) : (
						<p>Cargando información del paciente...</p>
					)}
				</div>
				<div className='p-5 border-2 rounded-md border-text-menu lg:w-1/2 w-full lg:mx-2 relative'>
					<h1 className='text-text-menu' style={{fontSize: '2em'}}>Datos Primera Vez</h1>
					{dataFirst && dataFirst.id_patient ? (
						<div>
							<h1 className='text-lg text-text-menu'>Antecedentes</h1>
							<p><strong>antecedentes patologicos: </strong>{dataFirst.antecedentes_patologicos}</p>
							<p><strong>antecedentes quirurgicos: </strong>{dataFirst.antecedentes_quirurgicos}</p>
							<h1 className='text-lg text-text-menu'>Toxicoalergicos</h1>
							<p><strong>alcohol: </strong>{dataFirst.alcohol}</p>
							<p><strong>tabaquismo: </strong>{dataFirst.tabaquismo}</p>
							<p><strong>drogas: </strong>{dataFirst.drogas}</p>
							<p><strong>inmunizaciones: </strong>{dataFirst.inmunizaciones}</p>
							<p><strong>otros toxico: </strong>{dataFirst.otros_toxico}</p>
							<h1 className='text-lg text-text-menu'>Antecedentes Familiares</h1>
							<p><strong>padre vivo: </strong>{dataFirst.padre_vivo}</p>
							<p><strong>padre enfermedades: </strong>{dataFirst.padre_enfermedades}</p>
							<p><strong>madre viva: </strong>{dataFirst.madre_viva}</p>
							<p><strong>madre enfermedades: </strong>{dataFirst.madre_enfermedades}</p>
							<p><strong>hermanos cuantos: </strong>{dataFirst.hermanos_cuantos}</p>
							<p><strong>hermanos vivos: </strong>{dataFirst.hermanos_vivos}</p>
							<p><strong>hermanos enfermedades: </strong>{dataFirst.hermanos_enfermedades}</p>
							<p><strong>otros familiares: </strong>{dataFirst.otros_familiares}</p>
							<h1 className='text-lg text-text-menu'>Cabeza y Cuello</h1>
							<p><strong>cabeza cuello: </strong>{dataFirst.cabeza_cuello}</p>
							<p><strong>lengua: </strong>{dataFirst.lengua}</p>
							<p><strong>torax: </strong>{dataFirst.torax}</p>
							<p><strong>abdomen: </strong>{dataFirst.abdomen}</p>
							<p><strong>extremidades: </strong>{dataFirst.extremidades}</p>
							<p><strong>pulso: </strong>{dataFirst.pulso}</p>
							<p><strong>neurologico: </strong>{dataFirst.neurologico}</p>
							<div className='absolute bottom-2 right-2'>
								{!actionFirst.isEdit && <PiNotePencil size={35} color='#B71C1C' style={{cursor: 'pointer'}} onClick={() => editFirstForm(dataFirst._id)}/>}
							</div>
						</div>
					) : (
						<button className='bg-red-600 text-white p-1.5 rounded-md hover:bg-red-700 text-sm my-2' type="button" onClick={() => setActionFirst({isView: true, isAdd: true, isEdit: false})}>
							Ingresar Visita Primera Vez
						</button>
					)}
				</div>
			</div>
			<div>
				<Evolution userId={userId} dataPatient={dataPatient} dataFirst={dataFirst} printDiv={printDiv}/>
			</div>
		</div>
	)
}

export default PatientMore